import type { RouteRecordRaw } from 'vue-router';
import { PermissionAction, PermissionResource } from '@nailsupply/review-swagger/auth';
import { allStoreRoutes } from '@/pages/store/routes';

export const storeRoutes: RouteRecordRaw = {
  path: '',
  component: () => import('@/layouts/main.vue'),
  meta: {
    requireAuth: true,
    requireStoreId: true,
    permission: { resource: PermissionResource.enum.store, action: PermissionAction.enum.view },
  },
  children: [
    ...allStoreRoutes,
  ],
};
